import { Component, OnInit,Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-verification-response',
  templateUrl: './verification-response.component.html',
  styleUrls: ['./verification-response.component.css']
})
export class VerificationResponseComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<VerificationResponseComponent>,@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
     
  }


}
